var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 332,
    viewBox: "0 0 524 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.311 12.8688C446.884 9.7135 437.566 14.1838 434.499 22.8536C431.432 31.5233 435.778 41.1094 444.205 44.2648C452.632 47.4201 461.95 42.9498 465.017 34.28C468.084 25.6103 463.739 16.0241 455.311 12.8688Z",
    fill: "#16162C",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.863 29.2246C461.996 30.4974 458.285 30.2473 454.728 28.4291C449.404 25.7244 444.875 25.1108 440.545 29.0655C437.673 31.6792 435.508 32.9975 434.049 32.9975C430.426 38.4977 428.99 42.0661 429.741 43.6798C430.493 45.2935 431.951 45.8617 434.138 45.3389C434.226 49.0891 435.198 51.2483 437.054 51.7938C438.91 52.3393 440.545 51.6574 442.003 49.7028C443.395 52.4302 445.096 53.8166 447.15 53.8166C449.183 53.8393 450.884 52.4756 452.254 49.771C455.413 52.2256 457.755 52.9529 459.323 51.9301C460.892 50.9074 461.687 49.3846 461.687 47.3618C464.868 48.6118 466.967 48.6345 468.028 47.4072C469.088 46.1799 469.088 44.7025 468.006 42.9979C471.695 44.2253 473.75 44.0661 474.147 42.5661C474.545 41.066 474.059 39.4978 472.667 37.9295C474.125 36.5658 474.412 35.1567 473.485 33.702C472.535 32.2474 470.016 30.7701 465.863 29.2246Z",
    fill: "#16162C",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M449.953 35.8388C447.147 33.6114 444.828 33.8842 442.994 36.7025",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.129 281.405C115.019 289.86 118.2 294.883 124.651 296.52C134.327 298.952 148.864 296.883 153.172 311.588C157.48 326.294 140.845 331.18 125.424 330.544C116.123 330.157 102.404 329.794 84.288 329.476C81.1067 329.407 78.5882 326.726 78.6544 323.453C78.6544 323.407 78.6544 323.362 78.6544 323.316L80.2893 282.724L115.129 281.405Z",
    fill: "#16162C",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.129 281.405C115.019 288.724 118.2 293.065 124.651 294.474C134.327 296.565 148.864 294.792 153.172 307.497C157.48 320.202 140.845 324.453 125.424 323.907C116.123 323.566 102.426 323.271 84.3322 322.975C81.1509 322.93 78.6323 320.248 78.6765 316.975C78.6765 316.907 78.6765 316.839 78.6765 316.771L80.2893 282.542L115.129 281.405Z",
    fill: "#16162C",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.543 288.679C118.045 291.679 120.741 293.611 124.651 294.475C134.327 296.566 148.864 294.793 153.172 307.498C157.48 320.203 140.845 324.453 125.424 323.908C116.123 323.567 102.426 323.271 84.3322 322.976C81.1509 322.93 78.6323 320.248 78.6765 316.976C78.6765 316.907 78.6765 316.839 78.6765 316.771L79.8474 291.724C96.9249 296.293 105.165 297.656 104.591 295.815C100.681 283.61 116.145 287.906 116.543 288.679Z",
    fill: "#16162C",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2481 305.998C91.5536 306.362 97.6953 312.021 97.6953 322.953",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.94 147.798C111.774 164.026 113.188 182.254 114.204 202.414C115.22 222.597 116.59 249.712 118.291 283.759H73.6425L71.2344 147.798H109.94Z",
    fill: "#16162C",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.472 79.8906L148.866 90.4138L197.138 46.1846L214.326 64.8445L162.807 121.097C156.334 128.166 145.597 128.666 138.527 122.233L115.617 101.369L136.472 79.8906Z",
    fill: "#16162C",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5532 89.817L118.634 64.8592L144.404 84.8474L122.802 109.496L98.5532 89.817Z",
    fill: "#6F44FF",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8342 281.405C68.7237 289.86 71.905 294.883 78.356 296.52C88.0325 298.952 102.569 296.883 106.877 311.588C111.185 326.294 94.5498 331.18 79.1293 330.544C69.8284 330.157 56.1089 329.794 37.9931 329.476C34.8118 329.407 32.2932 326.726 32.3595 323.453C32.3595 323.407 32.3595 323.362 32.3595 323.316L33.9944 282.724L68.8342 281.405Z",
    fill: "#16162C",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8342 281.405C68.7237 288.724 71.905 293.065 78.356 294.474C88.0325 296.565 102.569 294.792 106.877 307.497C111.185 320.202 94.5498 324.453 79.1293 323.907C69.8283 323.566 56.131 323.271 38.0373 322.975C34.8559 322.93 32.3374 320.248 32.3816 316.975C32.3816 316.907 32.3816 316.839 32.3816 316.771L33.9943 282.542L68.8342 281.405Z",
    fill: "#16162C",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2481 288.679C71.7504 291.679 74.4457 293.611 78.356 294.475C88.0325 296.566 102.569 294.793 106.877 307.498C111.185 320.203 94.5498 324.453 79.1293 323.908C69.8283 323.567 56.131 323.271 38.0373 322.976C34.8559 322.93 32.3374 320.248 32.3816 316.976C32.3816 316.907 32.3816 316.839 32.3816 316.771L33.5525 291.724C50.63 296.293 58.8705 297.656 58.2961 295.815C54.3857 283.61 69.8504 287.906 70.2481 288.679Z",
    fill: "#16162C",
    stroke: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9986 147.798C78.7102 166.481 79.9473 184.959 78.7102 203.278C77.473 221.597 76.2358 248.416 74.9986 283.759H26.7266C35.0554 249.598 39.2309 226.21 39.2309 213.574C39.2309 194.618 30.2393 170.753 36.8449 147.798H74.9986Z",
    fill: "#16162C",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8254 153.849C49.7103 159.644 45.093 163.054 39.0176 164.099",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1533 24.9369C70.8905 14.8002 64.3015 5.13221 54.4363 3.34283C44.5712 1.55346 35.1656 8.3203 33.4284 18.457C31.6912 28.5937 38.2802 38.2617 48.1454 40.0511C58.0105 41.8404 67.4161 35.0736 69.1533 24.9369Z",
    fill: "#16162C",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5421 37.4582C61.1301 44.276 64.547 51.8145 71.1741 54.2959C77.8011 56.7774 85.1288 53.2621 87.5408 46.4443C89.9529 39.6265 86.5359 32.088 79.9088 29.6065C73.2818 27.1251 65.9541 30.6404 63.5421 37.4582Z",
    fill: "#16162C",
    stroke: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9684 39.5215C64.3307 41.1201 66.1064 42.4138 68.2032 43.199C74.8257 45.6787 82.1596 42.1605 84.57 35.3474C84.7664 34.7921 84.9289 34.1999 85.0555 33.6426",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.376 47.7715C77.5962 46.0148 79.4005 46.2309 80.8514 48.4431",
    stroke: "white",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6881 56.1255L92.6888 56.1254C98.1267 54.8156 103.843 55.726 108.588 58.6995L108.593 58.7022L117.826 64.3534L107.673 81.3614L107.487 81.6743L107.727 81.9479C111.318 86.0318 112.947 90.4797 112.657 95.3072C112.367 100.152 110.141 105.435 105.911 111.163L105.767 111.358L105.831 111.592C108.878 122.711 110.832 131.363 111.703 137.562C112.139 140.663 112.3 143.13 112.198 144.976C112.095 146.853 111.723 147.97 111.211 148.501C111.062 148.655 110.673 148.87 109.955 149.11C109.263 149.34 108.342 149.57 107.217 149.793C104.97 150.24 101.951 150.656 98.4117 151.023C91.3347 151.755 82.2101 152.286 73.0732 152.473C63.9346 152.661 54.7982 152.504 47.6945 151.866C44.1405 151.546 41.1126 151.108 38.8533 150.537C37.723 150.252 36.802 149.937 36.1096 149.597C35.4068 149.251 34.9971 148.907 34.8108 148.594C33.5363 146.433 33.4535 143.217 34.7439 138.824C36.0296 134.446 38.6501 129 42.6279 122.471L42.7434 122.281L42.6802 122.068L39.0349 109.795L38.7598 108.869L38.1626 109.628L32.5535 116.761L8.86867 88.9014C20.1968 74.5421 30.2697 64.4405 39.0899 58.5582C47.9805 52.6289 55.5038 51.045 61.7427 53.5575L61.9294 53.0939L61.7427 53.5575C72.1062 57.7305 82.4188 58.583 92.6881 56.1255Z",
    fill: "#6F44FF",
    stroke: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5059 81.2539L44.8093 103.073",
    stroke: "white",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2627 110.187L34.4023 93.3457",
    stroke: "white",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 81.2539C112.858 87.9588 114.117 95.2318 111.068 103.073",
    stroke: "white",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.422 54.8175L191.359 51.0719C191.228 47.4004 192.116 44.3838 193.975 42.0179C196.777 38.4753 193.134 31.2627 197.764 29.3384C200.857 28.0528 203.215 31.5095 204.81 39.6959C209.797 36.9854 213.725 33.7596 216.662 30.0139C221.033 24.3976 225.046 30.7943 223.063 33.874C226.238 33.9513 227.381 35.8296 226.462 39.4963C229.57 40.0677 230.565 42.1786 229.449 45.8292C232.07 46.799 232.733 48.852 231.378 52.0139C230.023 55.1757 221.403 62.2885 204.736 72.6968",
    fill: "#16162C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 54.8175L191.359 51.0719C191.228 47.4004 192.116 44.3838 193.975 42.0179C196.777 38.4753 193.134 31.2627 197.764 29.3384C200.857 28.0528 203.215 31.5095 204.81 39.6959C209.797 36.9854 213.725 33.7596 216.662 30.0139C221.033 24.3976 225.046 30.7943 223.063 33.874C226.238 33.9513 227.381 35.8296 226.462 39.4963C229.57 40.0677 230.565 42.1786 229.449 45.8292C232.07 46.799 232.733 48.852 231.378 52.0139C230.023 55.1757 221.403 62.2885 204.736 72.6968",
    stroke: "white",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.699 34.2216C219.91 37.9794 216.299 41.4658 211.908 44.6638",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.529 40.5214C223.74 44.2792 220.129 47.7656 215.738 50.9636",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.466 45.626C226.758 49.1049 224.53 51.6241 222.8 53.2257",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9726 49.0975L111.404 77.1669C112.663 82.2581 111.58 86.281 108.178 89.2356C104.754 92.1903 100.6 92.6903 95.718 90.7584L72.2336 66.5528C70.5988 64.8709 70.0244 62.4163 70.7093 60.1434C71.8802 56.3478 74.2662 53.0977 77.9335 50.4157C81.4462 47.8247 84.9368 46.4155 88.3612 46.1655C90.5925 46.0292 92.7576 47.1428 93.9726 49.0975Z",
    fill: "#16162C",
    stroke: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7778 91.7364C98.6778 94.0547 103.649 92.941 107.912 89.2591C112.176 85.5771 114.098 80.6905 112.198 78.3722C110.298 76.0539 105.328 77.1676 101.064 80.8496C96.7999 84.5543 94.8779 89.4182 96.7778 91.7364Z",
    fill: "#16162C",
    stroke: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26186 91.6052C-3.48549 120.788 -1.32043 135.175 15.7129 134.766C32.7462 134.357 56.7165 118.334 87.6018 86.6504L74.1033 68.9678L18.1872 101.765L9.26186 91.6052Z",
    fill: "#16162C",
    stroke: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2325 80.613L94.9935 80.7982L93.4154 82.021C92.1092 83.033 90.3675 84.3823 88.6252 85.7312C86.8828 87.0802 85.1399 88.4289 83.8313 89.4398C83.177 89.9452 82.6315 90.3661 82.2491 90.6602C82.1823 90.7116 82.1206 90.759 82.0642 90.8023C81.9726 90.6659 81.8598 90.4981 81.7259 90.2992C81.311 89.6829 80.692 88.7654 79.8687 87.5456C79.5119 87.017 79.1168 86.4316 78.6832 85.7892C77.1424 83.5066 75.1165 80.5054 72.6043 76.7808L76.2671 63.3559L76.2846 63.2918L76.2849 63.225L76.3031 58.854C76.3031 58.854 76.3031 58.854 76.3031 58.854C76.3103 57.1986 77.4277 55.8011 78.9726 55.4759L78.9726 55.476L78.9758 55.4753C80.4859 55.147 82.0035 56.0024 82.5502 57.5034C82.5503 57.5036 82.5504 57.5039 82.5505 57.5042L85.1921 64.8529L85.2116 64.9071L85.2426 64.9557C88.6545 70.2966 91.2142 74.3085 92.9208 76.9852C93.7741 78.3235 94.4141 79.3281 94.8409 79.998L95.2325 80.613Z",
    fill: "#16162C",
    stroke: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7887 70.3148L75.5446 63.1231L76.1291 58.7465C76.375 56.8552 77.7571 55.341 79.6126 54.9474C81.3133 54.5926 83.0099 55.7116 83.3831 57.4477L85.4988 64.6252C92.4417 75.3034 95.9207 80.6211 95.9207 80.6211C95.9207 80.6211 90.742 85.0916 80.3771 94.0537",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8242 75.6056C92.0393 74.2192 93.7625 72.31 95.9718 69.9008L94.6462 68.128C98.645 67.378 101.075 68.1507 101.915 70.4235C103.174 73.8328 95.7508 82.1513 93.1881 81.9013",
    fill: "#16162C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8242 75.6056C92.0393 74.2192 93.7625 72.31 95.9718 69.9008L94.6462 68.128C98.645 67.378 101.075 68.1507 101.915 70.4235C103.174 73.8328 95.7508 82.1513 93.1881 81.9013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.248 72.1962C88.3527 70.6962 89.9433 68.6506 91.9979 66.0596L90.4735 64.3777C94.5165 63.3095 97.0792 63.9004 98.1617 66.105C99.7745 69.4461 92.97 78.3556 90.3189 78.3329",
    fill: "#16162C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87.248 72.1962C88.3527 70.6962 89.9433 68.6506 91.9979 66.0596L90.4735 64.3777C94.5165 63.3095 97.0792 63.9004 98.1617 66.105C99.7745 69.4461 92.97 78.3556 90.3189 78.3329",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7715 65.1722C85.8761 63.6721 87.4889 61.6493 89.4993 59.0583V55.4445C94.6026 53.6262 96.1049 57.8991 96.4142 59.0583C97.4526 62.8993 90.3388 72.0588 87.7319 72.0361",
    fill: "#16162C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7715 65.1722C85.8761 63.6721 87.4889 61.6493 89.4993 59.0583V55.4445C94.6026 53.6262 96.1049 57.8991 96.4142 59.0583C97.4526 62.8993 90.3388 72.0588 87.7319 72.0361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.435 281.42C407.546 289.875 404.364 294.898 397.913 296.512C388.237 298.943 373.7 296.875 369.392 311.558C365.084 326.24 381.72 331.149 397.14 330.513C406.441 330.127 420.161 329.763 438.276 329.445C441.458 329.377 443.976 326.695 443.91 323.422C443.91 323.376 443.91 323.331 443.91 323.285L442.275 282.738L407.435 281.42Z",
    fill: "#16162C",
    stroke: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.435 281.42C407.546 288.738 404.364 293.08 397.913 294.489C388.237 296.58 373.7 294.807 369.392 307.512C365.084 320.217 381.72 324.467 397.14 323.899C406.441 323.558 420.139 323.263 438.232 322.967C441.414 322.922 443.932 320.24 443.888 316.967C443.888 316.899 443.888 316.831 443.888 316.762L442.275 282.556L407.435 281.42Z",
    fill: "#16162C",
    stroke: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.021 288.693C404.519 291.694 401.824 293.625 397.913 294.466C388.237 296.557 373.7 294.785 369.392 307.49C365.084 320.195 381.72 324.445 397.14 323.877C406.441 323.536 420.139 323.24 438.232 322.945C441.414 322.9 443.932 320.218 443.888 316.945C443.888 316.877 443.888 316.808 443.888 316.74L442.717 291.739C425.64 296.307 417.399 297.671 417.973 295.83C421.884 283.625 406.419 287.921 406.021 288.693Z",
    fill: "#16162C",
    stroke: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M443.312 305.989C431.007 306.353 424.865 312.012 424.865 322.945",
    stroke: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.626 147.852C410.792 164.08 409.378 182.285 408.362 202.468C407.346 222.65 405.976 249.743 404.275 283.79H448.924L451.332 147.852H412.626Z",
    fill: "#16162C",
    stroke: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.619 79.9363L375.203 90.4595L326.909 46.2529L309.721 64.8901L361.285 121.12C367.758 128.166 378.472 128.666 385.542 122.256L408.474 101.392L387.619 79.9363Z",
    fill: "#16162C",
    stroke: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M401.197 109.654L379.594 84.9379L405.386 64.9049L425.446 89.93L401.197 109.654Z",
    fill: "#00E7FF",
    stroke: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.162 281.419C455.272 289.874 452.091 294.897 445.64 296.511C435.964 298.942 421.427 296.874 417.119 311.557C412.811 326.239 429.446 331.148 444.867 330.512C454.168 330.126 467.887 329.762 486.025 329.444C489.206 329.376 491.725 326.694 491.659 323.421C491.659 323.375 491.659 323.33 491.659 323.284L490.002 282.714L455.162 281.419Z",
    fill: "#16162C",
    stroke: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.162 281.419C455.272 288.737 452.091 293.079 445.64 294.488C435.964 296.579 421.427 294.806 417.119 307.511C412.811 320.216 429.446 324.466 444.867 323.898C454.168 323.557 467.865 323.262 485.959 322.966C489.14 322.921 491.659 320.239 491.614 316.966C491.614 316.898 491.614 316.83 491.614 316.761L490.024 282.555L455.162 281.419Z",
    fill: "#16162C",
    stroke: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.748 288.691C452.246 291.692 449.528 293.624 445.64 294.464C435.964 296.555 421.427 294.783 417.119 307.488C412.811 320.193 429.446 324.443 444.867 323.875C454.168 323.534 467.865 323.239 485.959 322.943C489.14 322.898 491.659 320.216 491.614 316.943C491.614 316.875 491.614 316.806 491.614 316.738L490.444 291.737C473.366 296.305 465.104 297.669 465.7 295.828C469.632 283.623 454.146 287.919 453.748 288.691Z",
    fill: "#16162C",
    stroke: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.995 147.852C445.283 166.511 444.046 185.012 445.283 203.331C446.521 221.65 447.758 248.47 448.995 283.79H497.289C488.96 249.629 484.785 226.241 484.785 213.627C484.785 194.672 493.776 170.807 487.171 147.852H448.995Z",
    fill: "#16162C",
    stroke: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M471.217 153.985C474.376 159.758 479.015 163.168 485.135 164.213",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M431.441 56.1713L431.442 56.1714C441.711 58.6289 452.024 57.7765 462.366 53.6033C468.593 51.0911 476.111 52.6747 484.996 58.604C493.81 64.4863 503.878 74.5879 515.195 88.9472L491.51 116.807L485.901 109.674L485.304 108.914L485.029 109.841L481.384 122.114L481.32 122.327L481.436 122.516C485.414 129.046 488.034 134.492 489.317 138.869C490.605 143.262 490.516 146.478 489.232 148.638L489.231 148.639C489.045 148.952 488.636 149.297 487.932 149.643C487.24 149.983 486.32 150.298 485.19 150.583C482.932 151.154 479.906 151.592 476.354 151.912C469.254 152.55 460.124 152.707 450.991 152.519C441.859 152.332 432.74 151.801 425.667 151.069C422.13 150.702 419.113 150.286 416.867 149.839C415.742 149.616 414.822 149.386 414.131 149.156C413.414 148.917 413.025 148.701 412.875 148.547C412.796 148.464 412.672 148.24 412.548 147.776C412.429 147.33 412.325 146.727 412.241 145.958C412.073 144.421 411.987 142.276 411.987 139.513C411.987 133.989 412.329 126.048 413.013 115.675L413.016 115.644L413.014 115.613C412.462 106.249 412.475 98.7621 413.048 93.1381C413.335 90.3263 413.76 87.9926 414.32 86.129C414.881 84.2609 415.569 82.8957 416.359 81.9931L416.598 81.72L416.413 81.408L406.281 64.3765L415.493 58.7251L415.494 58.7246C420.286 55.7714 426.004 54.8616 431.441 56.1713Z",
    fill: "#00E7FF",
    stroke: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M480.495 81.2539L479.17 103.073",
    stroke: "white",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M484.693 110.12L489.554 93.3008",
    stroke: "white",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.611 54.8244L332.674 51.0787C332.805 47.4073 331.925 44.3696 330.059 42.0247C327.256 38.4821 330.899 31.2695 326.27 29.3453C323.176 28.0596 320.818 31.5163 319.223 39.7028C314.256 37.0008 310.308 33.7664 307.392 30.0292C303.021 24.413 299.008 30.8097 300.991 33.8893C297.815 33.9666 296.673 35.8449 297.592 39.5117C294.484 40.083 293.488 42.194 294.604 45.8445C291.984 46.8143 291.32 48.8674 292.676 52.0292C294.011 55.1825 302.651 62.3039 319.317 72.7121",
    fill: "#16162C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M335.611 54.8244L332.674 51.0787C332.805 47.4073 331.925 44.3696 330.059 42.0247C327.256 38.4821 330.899 31.2695 326.27 29.3453C323.176 28.0596 320.818 31.5163 319.223 39.7028C314.256 37.0008 310.308 33.7664 307.392 30.0292C303.021 24.413 299.008 30.8097 300.991 33.8893C297.815 33.9666 296.673 35.8449 297.592 39.5117C294.484 40.083 293.488 42.194 294.604 45.8445C291.984 46.8143 291.32 48.8674 292.676 52.0292C294.011 55.1825 302.651 62.3039 319.317 72.7121",
    stroke: "white",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M301.334 34.2284C304.115 38.0073 307.726 41.4937 312.126 44.6706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.504 40.5283C300.285 44.3071 303.896 47.7935 308.296 50.9704",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M294.585 45.6416C297.293 49.1206 299.521 51.6397 301.25 53.2413",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.035 49.2104L412.67 77.2571C411.411 82.3483 412.493 86.3712 415.896 89.3258C419.298 92.2805 423.451 92.7805 428.334 90.8486L451.708 66.6657C453.32 64.9838 453.917 62.5292 453.232 60.2791C452.083 56.4835 449.675 53.2333 446.03 50.5286C442.539 47.9376 439.071 46.5284 435.668 46.2784C433.415 46.1193 431.25 47.2558 430.035 49.2104Z",
    fill: "#16162C",
    stroke: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.228 91.8478C425.35 94.1661 420.379 93.0524 416.116 89.3704C411.852 85.6884 409.952 80.8018 411.83 78.4835C413.707 76.1652 418.678 77.2789 422.942 80.9609C427.206 84.6429 429.128 89.5295 427.228 91.8478Z",
    fill: "#16162C",
    stroke: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.738 91.5258C527.485 120.686 525.32 135.073 508.287 134.664C491.254 134.255 467.306 118.232 436.42 86.5937L449.919 68.9111L505.835 101.685L514.738 91.5258Z",
    fill: "#16162C",
    stroke: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M429.172 79.8742L428.783 80.4842L429.021 80.6684L430.599 81.8889C431.904 82.8988 433.645 84.2454 435.386 85.5917C437.128 86.9381 438.87 88.2841 440.177 89.2929C440.831 89.7974 441.377 90.2174 441.759 90.5109C441.831 90.5665 441.898 90.6175 441.958 90.6637C442.047 90.535 442.156 90.3763 442.285 90.1874C442.7 89.5826 443.318 88.673 444.141 87.4578C445.766 85.0601 448.186 81.4755 451.405 76.7027L447.743 63.2778L447.725 63.2137L447.725 63.1469L447.707 58.7759L447.707 58.7759L447.707 58.7739C447.706 57.1414 446.582 55.723 445.037 55.3978L445.037 55.3978L445.034 55.3971C443.524 55.0689 442.006 55.9244 441.459 57.4256C441.459 57.4258 441.459 57.4259 441.459 57.4261L438.81 64.7543L438.79 64.808L438.76 64.8562C435.348 70.1971 432.791 74.2018 431.088 76.8713C430.236 78.206 429.598 79.2069 429.172 79.8742Z",
    fill: "#16162C",
    stroke: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M451.227 70.2369L448.479 63.0666L447.873 58.6977C447.628 56.8065 446.245 55.2923 444.397 54.92C442.697 54.5652 441 55.6842 440.619 57.3989L438.504 64.5765C431.553 75.2333 428.082 80.5724 428.082 80.5724C428.082 80.5724 433.261 85.0428 443.625 94.005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.193 75.5255C431.978 74.1391 430.255 72.2299 428.046 69.8207L429.371 68.0479C425.373 67.2979 422.942 68.0706 422.103 70.3435C420.844 73.7527 428.267 82.0485 430.829 81.8213",
    fill: "#16162C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M433.193 75.5255C431.978 74.1391 430.255 72.2299 428.046 69.8207L429.371 68.0479C425.373 67.2979 422.942 68.0706 422.103 70.3435C420.844 73.7527 428.267 82.0485 430.829 81.8213",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.775 72.1386C435.671 70.6386 434.08 68.593 432.048 66.002L433.572 64.3201C429.529 63.2519 426.966 63.8428 425.884 66.0474C424.271 69.3658 431.076 78.298 433.727 78.2525",
    fill: "#16162C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M436.775 72.1386C435.671 70.6386 434.08 68.593 432.048 66.002L433.572 64.3201C429.529 63.2519 426.966 63.8428 425.884 66.0474C424.271 69.3658 431.076 78.298 433.727 78.2525",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.25 65.116C438.145 63.6387 436.533 61.5932 434.522 59.0249V55.4111C429.419 53.6155 427.917 57.8657 427.607 59.0249C426.569 62.8659 433.683 72.0254 436.29 72.0027",
    fill: "#16162C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M439.25 65.116C438.145 63.6387 436.533 61.5932 434.522 59.0249V55.4111C429.419 53.6155 427.917 57.8657 427.607 59.0249C426.569 62.8659 433.683 72.0254 436.29 72.0027",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M102.49 85.1182C124.296 105.96 135.209 132.711 135.209 165.395C135.209 214.397 168.105 234.216 213.682 234.216C259.258 234.216 259.281 276.263 295.578 268.763",
    stroke: "white",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M419.522 85.1182C399.837 93.7095 393.276 109.937 399.837 133.825C409.668 169.645 399.837 205.26 364.953 208.828C330.069 212.397 351.874 253.421 310.385 263.99",
    stroke: "white",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M318.115 269.672L323.417 274.672",
    stroke: "white",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M307.953 274.899L310.383 281.491",
    stroke: "white",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M295.691 276.263V283.308",
    stroke: "white",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M295.583 257.398L290.943 252.853",
    stroke: "white",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M305.41 255.126V250.58",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.6b8d5a0605437181c304c92f16edca5e.svg";
export { ForwardRef as ReactComponent };